import { Router } from '@angular/router';
import { BasePage } from './../../base.page';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from './../../../services/auth.service';
import { MessageResponseModel } from 'src/app/models/user.model';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoadingController, Platform, ToastController } from '@ionic/angular';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

@Component({
  selector: 'shc-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
})
export class ForgotPasswordPage extends BasePage implements OnInit {

  form: UntypedFormGroup;

  constructor(
    protected platform: Platform,
    protected userService: UserService,
    protected authService: AuthService,
    protected translate: TranslateService,
    private errorService: ErrorHandlerService,
    protected loadingCtrl: LoadingController,
    toastController: ToastController,
    private router: Router
  ) {
    super(platform, userService, authService, translate, loadingCtrl, toastController);
  }

  ngOnInit() {
    const emailPattern = '[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,63}';
    this.form = new UntypedFormGroup({
      email: new UntypedFormControl(null, [
        Validators.required,
        Validators.email,
        Validators.pattern(emailPattern)
      ]),
    });
  }

  onSend(): void {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      return;
    }
    this.loadingCtrl.create({
      message: this.translate.instant(marker('Loading'))
    }).then(loadingEl => {
      loadingEl.present();
      this.authService.forgot(this.form.value).subscribe(
        (res: MessageResponseModel) => {
          loadingEl.dismiss();
          this.errorService.showToast(res.message);
          this.router.navigate(['/auth/reset'], { state: { email: this.form.value?.email } });
        },
        error => {
          loadingEl.dismiss();
          this.errorService.handle(error);
        }
      );
    });
  }

}
